
<div class="container">
  <div class="row">
    <div class="col">
      <error class="mb-4" [error]="error"></error>
      <div class="card-item">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="required">Project ID</label>
              <input class="form-control" autoLinkToLabel type="text" [(ngModel)]="projectId" [disabled]="migrating">
            </div>
            <div class="form-group">
              <label class="required">TMC Environment</label>
              <select class="form-control" autoLinkToLabel [(ngModel)]="environmentName" [disabled]="migrating">
                <option *ngFor="let e of environments" [ngValue]="e.key">{{ e.value }} ({{ e.url }})</option>
              </select>
            </div>
            <div class="form-group">
              <button class="btn btn-primary" [disabled]="migrating" (click)="migrate()">Migrate</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="progress">
              <div class="progress-bar progress-bar-striped progress-bar-animated" *ngIf="!error &amp;&amp; !complete &amp;&amp; migrating" [style.width]="progress">{{ progress }}</div>
              <div class="progress-bar bg-success" *ngIf="!error &amp;&amp; complete" style="width: 100%">Complete</div>
              <div class="progress-bar bg-danger" *ngIf="error" style="width: 100%">Error</div>
            </div>
            <p>{{ status }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>